import { render, staticRenderFns } from "./ServiceRecordDetails.vue?vue&type=template&id=45f8a2b6&"
import script from "./ServiceRecordDetails.vue?vue&type=script&lang=js&"
export * from "./ServiceRecordDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports